module.exports = __webpack_public_path__ + "img/transfer.31cfddae.svg";